import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { createNumberBadge } from './NumberBadge';
import { NUMBER_BADGE_BASE_CLASSNAME } from './constants';
createComponents(".".concat(NUMBER_BADGE_BASE_CLASSNAME), createNumberBadge, NO_PATTERN_BUSINESS_LOGIC);
